<template>
  <section>
    <!-- <div class="sep"></div> -->
    <span @click="$emit('joinWPSVip')">{{`${type || 'WPS'}会员价限时全场特惠，可省￥${saved || 0}`}}</span>
    <img src="../../assets/images/signup-right.png" alt="">
  </section>
</template>

<script>
export default {
  props: ['price', 'type', 'saved']
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

section {
  height: rem(96);
  width: 100%;
  padding: 0 rem(30);
  // background-color: #F5F6F8;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // white-space: nowrap;
  // overflow: hidden; 
  // text-overflow:ellipsis;
  > img {
    width: rem(12);
    height: rem(24);
    vertical-align: middle;
  }
  span {
    color: #F69500;
    font-size: rem(24);
    line-height: rem(96);
  }

  em {
    font-size: rem(26);
    line-height: rem(96);
    margin-right: rem(15);
  }
}
</style>
